var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessLeadership = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Workflow-Teamwork-Increasing-Arrow--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Workflow Teamwork Increasing Arrow Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.39a0.21 0.21 0 0 1 0.07 0.29 0.27 0.27 0 0 1 -0.1 0.08 5.23 5.23 0 0 0 -3.18 4.82 0.42 0.42 0 0 0 0.42 0.42h9.64a0.42 0.42 0 0 0 0.42 -0.42A5.24 5.24 0 0 0 14 18.76a0.23 0.23 0 0 1 -0.11 -0.28 0.28 0.28 0 0 1 0.09 -0.1A4 4 0 1 0 8.58 17 4 4 0 0 0 10 18.39ZM9.69 15a1.89 1.89 0 0 1 0.06 -0.47 0.42 0.42 0 0 1 0.5 -0.32l0.12 0.05A5.13 5.13 0 0 0 13 15a6.13 6.13 0 0 0 0.74 -0.05 0.4 0.4 0 0 1 0.47 0.35 0.29 0.29 0 0 1 0 0.13A2.29 2.29 0 0 1 9.69 15Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77 21.61a0.42 0.42 0 0 0 -0.27 -0.53l-0.13 0a3.77 3.77 0 0 0 -3.49 2.36 0.42 0.42 0 0 0 0.22 0.56 0.45 0.45 0 0 0 0.16 0H5a0.42 0.42 0 0 0 0.42 -0.42 6.59 6.59 0 0 1 0.35 -1.97Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05 17.92a2.31 2.31 0 1 0 4.62 0 2.31 2.31 0 1 0 -4.62 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h3.5a37.17 37.17 0 0 1 -2.66 7.15 4.9 4.9 0 0 1 0.54 0 3.79 3.79 0 0 1 1.18 0.19 5.51 5.51 0 0 1 10.92 0 3.79 3.79 0 0 1 1.18 -0.19 3.68 3.68 0 0 1 0.58 0.05A37.11 37.11 0 0 1 16.57 7H20a0.51 0.51 0 0 0 0.47 -0.34 0.5 0.5 0 0 0 -0.17 -0.56l-8 -6a0.51 0.51 0 0 0 -0.6 0l-8 6a0.49 0.49 0 0 0 -0.18 0.56A0.51 0.51 0 0 0 4 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23 21.61a0.42 0.42 0 0 1 0.27 -0.53l0.13 0a3.77 3.77 0 0 1 3.49 2.36 0.42 0.42 0 0 1 -0.23 0.55 0.45 0.45 0 0 1 -0.16 0H19a0.42 0.42 0 0 1 -0.42 -0.42 6.59 6.59 0 0 0 -0.35 -1.96Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.33 17.92a2.31 2.31 0 1 0 4.62 0 2.31 2.31 0 1 0 -4.62 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessLeadership);
export default ForwardRef;